
export class EngagementTeam {

    engagementManager: string;
    engagementManagerEmail: string;
    enterprisePartnershipManager: string;
    enterprisePartnershipManagerEmail: String;

    constructor() {
        this.engagementManager = "";
        this.engagementManagerEmail = "";
        this.enterprisePartnershipManager = "";
        this.enterprisePartnershipManagerEmail = "";
    }

}